<div class="container">
  <div class="row" style="height: 5px; background-color: #431a2a; margin-bottom: 15px; margin-top: 10px;"></div>
  <div class="row">
    <div class="col">
      <img src="../../../assets/images/physioLife logo artwork-02.png" alt="smartlab"
        class="img-fluid float-start" width="50px" height="50px">
      <h2 style="color: #431a2a;"> PHYSIOLIFE CLINIC </h2>
    </div>
  </div>
  <div class="row">
    <br>
    </div>
    <div class="row">
      <div class="col">
        <div class="side_border">
          <p style="font-size: medium; color: #431a2a;">PATIENT INFORMATION</p>
          {{patient?.first_name}} {{patient?.last_name}} <br>
          {{patient?.patient_number}} <br>
          {{patient?.phone}}
        </div>
      </div>
      <div class="col">
        <div class="side_border">
          <p style="font-size: medium; color: #431a2a;">Clinician INFORMATION</p>
          {{appointment.doctor}} <br>
          {{appointment?.date | date}} <br>
          {{appointment?.service }} <br>
        </div>
      </div>
    </div>

    <hr style="margin-top: 15px; height:2px;border:none;color:#431a2a;background-color:#431a2a;">

    <div class="row" style="border: 1px solid #e1e3e7; border-radius: 5px;">
      <table class="table" style="margin: 0px;">
        <tbody>
          @for (item of notes; track item) {
            <tr>
              <td>
                <pre>{{item?.created_at | date}}</pre>
                <p [ngStyle]="{ 'white-space': 'pre-wrap' }">{{item?.description}}</p>
              </td>
            </tr>
          }
        </tbody>
      </table>

      <div class="col" style="padding-right: 5px;">
        <img src="../../../assets/images/stamp.png" alt="physioLife" class="float-end" height="150px" width="150px"
          style="margin-top:-30px; margin-bottom:-150px">
      </div>
    </div>

    <div style="margin-top: 70px;">
      <button type="button" class="btn btn-outline-dark" id="myPrntbtn" onclick="window.print();">Print/Share</button>
    </div>
  </div>